<h1>Enter a name for this scenario</h1>
<input type="text" [(ngModel)]="name" />
<button (click)="close()"></button>
